<template>
  <q-avatar rounded>
    <img alt="CATI Spa" src="~assets/logo.png" />
  </q-avatar>
</template>
